module.exports = __webpack_public_path__ + "img/data_moun_yh.eaca1a3d.png";